import Curve from "../../../../src/content/ipt/spe/voyageur/curve.js";
import Center from 'components/Center.js';
import React from 'react';
export default {
  Curve,
  Center,
  React
};